import {
	MY_PATIENTS_ACTION_TYPES,
	MyPatientsAction,
	MyPatientsState,
} from './types'

const initialState: MyPatientsState = {
	list: [],
	selectedList: [],
	count: 0,
	searchValue: '',
	loading: false,
	filters: {
		plan: [],
		organization: [],
		membershipStatus: [],
		coach: [],
		account: [],
		state: [],
		gender: [],
		languages: [],
		ageGroup: [],
		diabetesType: [],
		availability: [],
		comorbidities: [],
		lastContact: [],
		mskType: [],
		dateStarted: null,
		billableAchieved: false,
		rpmBillableAchieved: false,
		country: '',
	},
}

export default (
	state = initialState,
	action: MyPatientsAction
): MyPatientsState => {
	switch (action.type) {
		case MY_PATIENTS_ACTION_TYPES.INIT: {
			return {
				...initialState,
				list: action.payload.list,
				count: action.payload.count,
				searchValue: state.searchValue,
			}
		}
		case MY_PATIENTS_ACTION_TYPES.GET: {
			return {
				...initialState,
				searchValue: state.searchValue,
				count: action.payload.count,
				list: action.payload.list,
			}
		}
		case MY_PATIENTS_ACTION_TYPES.SET_LOADING: {
			return {
				...state,
				loading: action.payload,
			}
		}
		case MY_PATIENTS_ACTION_TYPES.APPLY_FILTER: {
			const newMultiFilters = {
				...state.filters,
				[action.payload.key]: action.payload.value,
			}

			return {
				...state,
				filters: newMultiFilters,
				selectedList: [],
			}
		}
		case MY_PATIENTS_ACTION_TYPES.SET_SEARCH_VALUE: {
			return {
				...state,
				selectedList: [],
				searchValue: action.payload,
			}
		}
		case MY_PATIENTS_ACTION_TYPES.SELECT_ONE: {
			return {
				...state,
				selectedList: [...state.selectedList, action.payload],
			}
		}
		case MY_PATIENTS_ACTION_TYPES.DESELECT_ONE: {
			const newSelectedList = state.selectedList.filter(
				patient => patient._id !== action.payload
			)

			return {
				...state,
				selectedList: newSelectedList,
			}
		}
		case MY_PATIENTS_ACTION_TYPES.SELECT_ALL: {
			return {
				...state,
				selectedList: action.payload,
			}
		}
		case MY_PATIENTS_ACTION_TYPES.SELECT_ALL_PAGE: {
			const newSelectedList = [
				...new Map(
					[...state.selectedList, ...action.payload].map(item => [
						item._id,
						item,
					])
				).values(),
			]

			return {
				...state,
				selectedList: newSelectedList,
			}
		}
		case MY_PATIENTS_ACTION_TYPES.DESELECT_ALL_PAGE: {
			const deselectPatientsIds =
				action.payload?.map(patient => patient._id).join(',') || ''

			const newSelectedList = state.selectedList.filter(
				patient => !deselectPatientsIds.match(patient._id)
			)

			return {
				...state,
				selectedList: newSelectedList,
			}
		}
		case MY_PATIENTS_ACTION_TYPES.EDIT_PATIENT: {
			const newPatientsList = [
				...new Map(
					[...state.list, ...action.payload].map(item => [
						item.id,
						item,
					])
				).values(),
			]

			return {
				...state,
				list: newPatientsList,
			}
		}
		case MY_PATIENTS_ACTION_TYPES.CLEAR_ALL_FILTERS: {
			return {
				...state,
				filters: initialState.filters,
			}
		}
		case MY_PATIENTS_ACTION_TYPES.RESET: {
			return initialState
		}
		default: {
			return state
		}
	}
}
